var _desc, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Affiliate-quarter-dashboard1",
    transform: "translate(-40.000000, -242.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(40.000000, 242.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dashboard"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.70828246,-5.77315973e-14 L1.45828246,-5.77315973e-14 C0.654144297,-5.77315973e-14 -5.77315973e-14,0.654144297 -5.77315973e-14,1.45828246 L-5.77315973e-14,5.20828246 C-5.77315973e-14,6.01257324 0.654144297,6.66671754 1.45828246,6.66671754 L7.70828246,6.66671754 C8.51257324,6.66671754 9.16671754,6.01257324 9.16671754,5.20828246 L9.16671754,1.45828246 C9.16671754,0.654144297 8.51257324,-5.77315973e-14 7.70828246,-5.77315973e-14 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70828246,8.33328246 L1.45828246,8.33328246 C0.654144297,8.33328246 -5.77315973e-14,8.98742676 -5.77315973e-14,9.79171754 L-5.77315973e-14,18.5417175 C-5.77315973e-14,19.3458557 0.654144297,20 1.45828246,20 L7.70828246,20 C8.51257324,20 9.16671754,19.3458557 9.16671754,18.5417175 L9.16671754,9.79171754 C9.16671754,8.98742676 8.51257324,8.33328246 7.70828246,8.33328246 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5417175,13.3332825 L12.2917175,13.3332825 C11.4874268,13.3332825 10.8332825,13.9874268 10.8332825,14.7917175 L10.8332825,18.5417175 C10.8332825,19.3458557 11.4874268,20 12.2917175,20 L18.5417175,20 C19.3458557,20 20,19.3458557 20,18.5417175 L20,14.7917175 C20,13.9874268 19.3458557,13.3332825 18.5417175,13.3332825 L18.5417175,13.3332825 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5417175,-5.86197757e-14 L12.2917175,-5.86197757e-14 C11.4874268,-5.86197757e-14 10.8332825,0.654144297 10.8332825,1.45828246 L10.8332825,10.2082825 C10.8332825,11.0125732 11.4874268,11.6667175 12.2917175,11.6667175 L18.5417175,11.6667175 C19.3458557,11.6667175 20,11.0125732 20,10.2082825 L20,1.45828246 C20,0.654144297 19.3458557,-5.86197757e-14 18.5417175,-5.86197757e-14 L18.5417175,-5.86197757e-14 Z",
    id: "Path"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.e66647befa54c0ffa885773f56e77609.svg";
export { ForwardRef as ReactComponent };